/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IsoDayOfWeek,
    IsoDayOfWeekFromJSON,
    IsoDayOfWeekFromJSONTyped,
    IsoDayOfWeekToJSON,
    LocalDateLocalDateTuple,
    LocalDateLocalDateTupleFromJSON,
    LocalDateLocalDateTupleFromJSONTyped,
    LocalDateLocalDateTupleToJSON,
    LocalTimeLocalTimeTuple,
    LocalTimeLocalTimeTupleFromJSON,
    LocalTimeLocalTimeTupleFromJSONTyped,
    LocalTimeLocalTimeTupleToJSON,
} from './';

/**
 * 
 * @export
 * @interface DateTimeRestrictionData
 */
export interface DateTimeRestrictionData {
    /**
     * 
     * @type {Array<LocalDateLocalDateTuple>}
     * @memberof DateTimeRestrictionData
     */
    dateRanges?: Array<LocalDateLocalDateTuple> | null;
    /**
     * 
     * @type {Array<LocalTimeLocalTimeTuple>}
     * @memberof DateTimeRestrictionData
     */
    timeRanges?: Array<LocalTimeLocalTimeTuple> | null;
    /**
     * 
     * @type {Array<IsoDayOfWeek>}
     * @memberof DateTimeRestrictionData
     */
    weekDays?: Array<IsoDayOfWeek> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeRestrictionData
     */
    match?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DateTimeRestrictionData
     */
    comments?: string | null;
}

export function DateTimeRestrictionDataFromJSON(json: any): DateTimeRestrictionData {
    return DateTimeRestrictionDataFromJSONTyped(json, false);
}

export function DateTimeRestrictionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateTimeRestrictionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dateRanges': !exists(json, 'dateRanges') ? undefined : (json['dateRanges'] === null ? null : (json['dateRanges'] as Array<any>).map(LocalDateLocalDateTupleFromJSON)),
        'timeRanges': !exists(json, 'timeRanges') ? undefined : (json['timeRanges'] === null ? null : (json['timeRanges'] as Array<any>).map(LocalTimeLocalTimeTupleFromJSON)),
        'weekDays': !exists(json, 'weekDays') ? undefined : (json['weekDays'] === null ? null : (json['weekDays'] as Array<any>).map(IsoDayOfWeekFromJSON)),
        'match': !exists(json, 'match') ? undefined : json['match'],
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
    };
}

export function DateTimeRestrictionDataToJSON(value?: DateTimeRestrictionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dateRanges': value.dateRanges === undefined ? undefined : (value.dateRanges === null ? null : (value.dateRanges as Array<any>).map(LocalDateLocalDateTupleToJSON)),
        'timeRanges': value.timeRanges === undefined ? undefined : (value.timeRanges === null ? null : (value.timeRanges as Array<any>).map(LocalTimeLocalTimeTupleToJSON)),
        'weekDays': value.weekDays === undefined ? undefined : (value.weekDays === null ? null : (value.weekDays as Array<any>).map(IsoDayOfWeekToJSON)),
        'match': value.match,
        'comments': value.comments,
    };
}


